import React, { useState } from 'react';
import { HRCommandCenter } from './pages/HRCommandCenter';
import { Recruiting } from './pages/Recruiting';
import { Reports } from './pages/Reports';
import { Navbar } from './components/Navbar';
function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'recruiting' | 'reports'>('home');
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <Navbar currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-1" />
      <main data-id="element-2">
        {currentPage === 'home' ? <HRCommandCenter data-id="element-3" /> : currentPage === 'recruiting' ? <Recruiting data-id="element-4" /> : <Reports data-id="element-5" />}
      </main>
    </div>;
}
export { App };